<template>
  <audio
    ref="audio"
    :src="currentAudioSrc"
    @ended="playNextAudio"
    :autoplay="true"
  ></audio>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: [],
    },
    autoplay: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    list(newVal) {
      if (newVal && newVal.length > 0) {
        this.playCurrentAudio();
      }
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    currentAudioSrc() {
      return this.list?.length > 0 ? this.list[this.currentIndex] : "";
    },
  },
  mounted() {
    this.currentIndex = 0;
  },
  destroyed() {
    console.log("音频离开");
    this.pauseCurrentAudio();
  },
  methods: {
    updateVolume(volume) {
      const audio = this.$refs.audio;
      if (audio) {
        audio.volume = volume / 100; // 转换为 0 到 1 的范围
      }
    },
    playCurrentAudio() {
      if (this.list.length > 0) {
        const audio = this.$refs.audio;
        if (audio) {
          audio.load();
          audio.play();
        }
      }
    },
    pauseCurrentAudio() {
      const audio = this.$refs.audio;
      audio && audio.pause();
    },
    playNextAudio() {
      if (this.list.length == 1 && this.autoplay) {
        this.playCurrentAudio();
        return;
      }
      this.currentIndex++;
      if (this.list && this.currentIndex < this.list.length) {
        // 更改了音频 URL 后，需要重新加载音频资源
        this.playCurrentAudio();
      } else {
        if (this.autoplay) {
          this.currentIndex = 0; // 重置索引，循环播放
        }
      }
    },
  },
};
</script>
